<template>
  <v-container fluid class="loadingorder-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn @click="runLoadingDialog" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Load
              </v-btn>
              <v-btn color="success" class="button-shadow mr-3" @click="isFindLoading=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="loadingorders-table"
              show-select
              single-select
              item-key="_id"
              sort-desc
              sort-by="loadingordernum"
              :footer-props="footer"
              :headers="headers"
              :items="loadingorders_data"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Loading Order?
                    </v-card-title>
                    <v-card-text>
                      {{ deleteloadingorder.loadingordernum }} 
                      {{ deleteloadingorder.loadingordername }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deleteloadingorder)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.loadingorderimage="{ item }">
                    <v-img
                    v-if="item.loadingorderimage" 
                    v-bind:src="item.loadingorderimage"
                    max-height="70"
                    max-width="70"
                  ></v-img>
              </template>
              <template v-slot:item.driverid="{ item }">
                <p class="two-line" style="margin-left: 15px;">
                <v-avatar v-if="item.driverid!=null && users.length>0" size="40">
                  <img v-bind:src="users.find(user=>user._id == item.driverid)['userimage']" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="40">
                  <p class="two-line"><span class="white--text headline">{{ item.driverid!=null && users.length>0 ? users.find(user=>user._id == item.driverid)['username'][0].toUpperCase() : '' }}</span></p>
                </v-avatar>
                </p>
                <p class="two-line"><span style="margin-left:15px">{{ item.driverid!=null && users.length>0 ? users.find(user=>user._id == item.driverid)['username'] : '' }} </span></p>
              </template>
              <template v-slot:item.loaderid="{ item }">
                <p class="two-line" style="margin-left: 15px;">
                <v-avatar v-if="item.loaderid!=null && users.length>0" size="40">
                  <img v-bind:src="users.find(user=>user._id == item.loaderid)['userimage']" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="40">
                  <p class="two-line"><span class="white--text headline">{{ item.loaderid!=null && users.length>0 ? users.find(user=>user._id == item.loaderid)['username'][0].toUpperCase() : '' }}</span></p>
                </v-avatar>
                </p>
                <p class="two-line"><span style="margin-left:15px">{{ item.loaderid!=null && users.length>0 ? users.find(user=>user._id == item.loaderid)['username'] : '' }} </span></p>
              </template>
              <template v-slot:item.loadingordernum="{ item }">
                <p class="two-line">{{ item.loadingordertype  }}</p>
                <p class="two-line">{{ item.loadingordernum  }}</p>
                <p class="two-line">{{ new Date(item.loadingorderdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
              </template>
              <template v-slot:item.locationid="{ item }">
                <p class="two-line">{{ item.locationid!=null && locations.find(location=>location._id == item.locationid)!=null ? locations.find(location=>location._id == item.locationid)['locationname'] : '' }}</p>
                <p class="two-line">{{ item.vehicleid!=null && vehicles.find(vehicle=>vehicle._id == item.vehicleid)!=null ? vehicles.find(vehicle=>vehicle._id == item.vehicleid)['vehiclename'] : '' }}</p>
              </template>
              <template v-slot:item.orderquantity="{ item }">
                {{ item.orderquantity.toLocaleString('en-SG') }}
              </template>
              <template v-slot:item.orderweight="{ item }">
                {{ item.orderweight.toFixed(1) }}
              </template>
              <template v-slot:item.loadingorderstatus="{ item }">
                <v-chip
                  small
                  :color="item.loadingorderstatus=='New' ? 'primaryConst white--text' :  
                  item.loadingorderstatus=='Loaded' ? 'warning white--text' : 
                  item.loadingorderstatus=='Unloaded' ? 'greyTint white--text' : 
                  'secondaryConst white--text'">
                  {{ item.loadingorderstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="isRunLoading"
        persistent
        width="400px"
        max-width="400px"
        >
        <v-card>
          <v-card-title>
            <span class="text-h5">Create Loading Orders</span>
          </v-card-title>
            <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="12">
                  <v-menu
                          ref="menu_loadingorderdate"
                          v-model="menu_loadingorderdate"
                          :close-on-content-click="false"
                          :return-value.sync="newloading.loadingorderdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="newloading.loadingorderdate"
                              label="Loading Date"
                              v-bind="attrs"
                              v-bind:value="newloading.loadingorderdate"
                              v-on="on"
                              single-line hint="Please choose the loading date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="newloading.loadingorderdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_loadingorderdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_loadingorderdate.save(newloading.loadingorderdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                </v-col>
              </v-row>
            </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isRunLoading = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="runLoading"
              >
                Save
              </v-btn>
            </v-card-actions>
          
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isFindLoading"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Find Loading Orders</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    :items="['New', 'Loaded', 'Unloaded']"
                    v-model="query.orderstatus"
                    label="Loading Status"
                    required
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    class="mb-4"
                    type="number"
                    placeholder="Loading Num"
                    v-model="query.ordernum"
                    dense
                    oninput="if(this.value < 1) this.value = 1;"
                    single-line hint="Loading Num">
                  </v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <v-menu
                    ref="menu_startdate"
                    v-model="menu_startdate"
                    :close-on-content-click="false"
                    :return-value.sync="query.startdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="query.startdate"
                        label="Loading Start Date"
                        v-bind="attrs"
                        v-bind:value="query.startdate"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please enter start date">
                      ></v-text-field>
                    </template>
                      <v-date-picker
                        v-model="query.startdate"
                        no-title
                        scrollable
                      >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_startdate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_startdate.save(query.startdate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-menu
                    ref="menu_enddate"
                    v-model="menu_enddate"
                    :close-on-content-click="false"
                    :return-value.sync="query.enddate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="query.enddate"
                        label="Loading End Date"
                        v-bind="attrs"
                        v-bind:value="query.enddate"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please enter end date">
                      ></v-text-field>
                    </template>
                      <v-date-picker
                        v-model="query.enddate"
                        no-title
                        scrollable
                      >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_enddate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_enddate.save(query.enddate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isFindLoading = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="resetLoadingOrders"
            >
              Reset
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="findLoadingOrders"
            >
              Find
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import config from "../../../config";
import { mapState, mapActions } from 'vuex';
import { formatStdDate } from '@/mixins/date';

export default {
  name: 'LoadingOrderList',
  data() {
    return {
      config,
      snackbar: null,
      dialog: false,
      isRunLoading: false,
      isFindLoading: false,
      menu_loadingorderdate: false,
      deleteloadingorder: {},
      newloading: {},
      query: {},
      menu_startdate: null,
      menu_enddate: null,
      headers: [
        { text: 'Image', value: 'loadingorderimage', width: '5%', sortable: false },
        { text: 'Order', value: 'loadingordernum', width: '10%' },
        { text: 'Location-Vehicle', value: 'locationid' },
        { text: 'Driver', value: 'driverid', width: '12%' },
        { text: 'Loader', value: 'loaderid', width: '12%' },
        { text: 'Quantity', value: 'orderquantity' },
        { text: 'Weight (Kg)', value: 'orderweight' },
        { text: 'Status', value: 'loadingorderstatus' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      loadingorders_data: [],
    }
  },
  computed: {
    ...mapState('LoadingOrder', ['loadingorders', 'isReceiving', 'isDeleting', 'idToDelete', 'loadingordersMessage', 'isUpdating']),
    ...mapState('Location', ['locations']),
    ...mapState('User', ['users']),
    ...mapState('Vehicle', ['vehicles']),
  },
  async created () {
    if(this.loadingorders.length==0) await this.getLoadingOrdersRequest();
    this.loadingorders_data = Object.assign([], this.loadingorders);
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.users.length==0) await this.getUsersRequest();
    if(this.vehicles.length==0) await this.getVehiclesRequest();
  },
  methods: {
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('LoadingOrder', ["getLoadingOrdersRequest","findLoadingOrdersRequest", "deleteLoadingOrderRequest","runLoadingRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    ...mapActions('Vehicle', ["getVehiclesRequest"]),
    async findLoadingOrders(){
      this.isFindLoading = false;
      if(Object.keys(this.query).length==0){
        await this.getLoadingOrdersRequest();
        this.loadingorders_data = Object.assign([], this.loadingorders);
      }
      else{
        console.log(this.query)
        let result = await this.findLoadingOrdersRequest(this.query);
        this.loadingorders_data = Object.assign([], result);
      }
    },
    async resetLoadingOrders(){
      this.query = {};
    },
    editItem(item) {
      this.$router.push({ name: 'LoadingOrderEdit', params: item })
    },
    printItem(item) {
      this.$router.push({ name: 'LoadingOrderPrint', params: item })
    },
    viewItem(item) {
      this.$router.push({ name: 'LoadingOrderView', params: item })
    },
    deleteItem(item) {
      this.deleteLoadingOrderRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deleteloadingorder = {
        _id: item._id,
        loadingordernum: item.loadingordernum,
        loadingordername: item.loadingordername,
      }
    },
    runLoadingDialog() {
      let date = formatStdDate(new Date());
      this.newloading = {loadingorderdate: date};
      this.isRunLoading = true;
    },
    async runLoading(){
      await this.runLoadingRequest(this.newloading);
      await this.getLoadingOrdersRequest();
      this.loadingorders_data = Object.assign([], this.loadingorders);
      this.isRunLoading = false;
    }
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
